var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.023 27 1.334-8.687H17.02v-5.637c0-2.377 1.165-4.693 4.898-4.693h3.79V.587S22.268 0 18.981 0C12.117 0 7.63 4.16 7.63 11.693v6.62H0V27h7.63v21h9.391V27h7.002Z"
  })));
};
export default SvgFacebook;